// extracted by mini-css-extract-plugin
module.exports = {"containerWrapper":"Index_containerWrapper__CgpTi","containerWrapper-fluid":"Index_containerWrapper-fluid__9gY_r","sliderCustom":"Index_sliderCustom__1F_ZF"};